import { SupportedChainId } from 'constants/chains'

/**
 * Fallback JSON-RPC endpoints.
 * These are used if the integrator does not provide an endpoint, or if the endpoint does not work.
 *
 * MetaMask allows switching to any URL, but displays a warning if it is not on the "Safe" list:
 * https://github.com/MetaMask/metamask-mobile/blob/bdb7f37c90e4fc923881a07fca38d4e77c73a579/app/core/RPCMethods/wallet_addEthereumChain.js#L228-L235
 * https://chainid.network/chains.json
 *
 * These "Safe" URLs are listed first, followed by other fallback URLs, which are taken from chainlist.org.
 */
export const FALLBACK_URLS = {
  // [SupportedChainId.MAINNET]: [
  //   'https://eth.llamarpc.com',
  //   // "Safe" URLs
  //   'https://api.mycryptoapi.com/eth',
  //   'https://cloudflare-eth.com',
  //   // "Fallback" URLs
  //   'https://rpc.ankr.com/eth',
  //   'https://eth-mainnet.public.blastapi.io',
  // ],
  [SupportedChainId.ZK_SYNC]: ['https://mainnet.era.zksync.io'],
  [SupportedChainId.FANTOM]: ['https://rpc.ftm.tools/'],
  [SupportedChainId.ARBITRUM]: [
    // "Safe" URLs
    'https://arb1.arbitrum.io/rpc',
    // "Fallback" URLs
    'https://arbitrum.public-rpc.com',
  ],
}

/**
 * Known JSON-RPC endpoints.
 * These are the URLs used by the interface when there is not another available source of chain data.
 */
export const RPC_URLS = {
  // [SupportedChainId.MAINNET]: FALLBACK_URLS[SupportedChainId.MAINNET],
  [SupportedChainId.ZK_SYNC]: FALLBACK_URLS[SupportedChainId.ZK_SYNC],
  [SupportedChainId.FANTOM]: FALLBACK_URLS[SupportedChainId.FANTOM],
  [SupportedChainId.ARBITRUM]: FALLBACK_URLS[SupportedChainId.ARBITRUM],
}
